export default {
    "title": "設定",
    "profileDetails": {
        "title": "プロフィール詳細"
    },
    "myTechnologies": {
        "title": "登録テクノロジー"
    }
};
